import React, { useEffect, useState } from "react";

export default function ReviewFormRow({
  label,
  onValidate,
  RowData,
  EditForm,
  formData,
  readOnly,
  onChange,
  onClick,
  onBlur,
  hasError,
  setErrorMessage,
  errorMessage,
  requestRequiredFields,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [hasValidationError, setHasValidationError] = useState(false);

  useEffect(() => {
    if (requestRequiredFields) {
      // setIsEditing changed to false so manager fields are not defaulted to save instead of update
      setIsEditing(false);
      const checkInputs =
        typeof onValidate === "function" ? onValidate() : false;
      setHasValidationError(checkInputs);
    }
  }, [requestRequiredFields]);

  return (
    <div
      className={`grid grid-cols-12 items-start lg:items-center justify-start w-full lg:min-h-[60px] py-4 lg:py-1 ${
        hasValidationError ? "h-28" : "h-auto"
      }`}
    >
      <label className="col-span-12 lg:col-span-4 text-sm text-primary-600 font-medium mb-2 lg:mb-0">
        {label}
      </label>
      <div className="col-span-10 lg:col-span-6">
        {!isEditing ? (
          <span className="text-primary-800 text-sm font-normal">
            <RowData />
          </span>
        ) : (
          <EditForm
            onChange={onChange}
            formData={formData}
            onBlur={onBlur}
            hasError={hasValidationError || hasError}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
          />
        )}
      </div>
      {!readOnly && (
        <div className="col-span-2 text-right">
          <button
            type="button"
            onClick={() => {
              if (isEditing) {
                try {
                  const checkInputs =
                    typeof onValidate === "function" ? onValidate() : false;
                  setHasValidationError(checkInputs);
                  if (!checkInputs) {
                    setIsEditing(!isEditing);
                    if (typeof onClick === "function") {
                      onClick();
                    }
                    if (typeof onChange === "function") {
                      onChange(formData);
                    }
                  }
                } catch (error) {
                  console.log(error);
                }
              } else {
                setIsEditing(true);
              }
            }}
            className={`border-0 bg-transparent text-sm font-medium ${
              isEditing ? "text-system-green" : "text-brand-500"
            }`}
          >
            {isEditing ? "Save" : "Update"}
          </button>
        </div>
      )}
    </div>
  );
}
